<template>
	<span v-if="display" id="com.birdeatsbug.app.installButton" class="button-yellow pr-8 pl-12">
		<a :href="$env.VUE_APP_EXTENSION_URL" target="_blank" class="whitespace-nowrap" @click="onButtonClick">
			Get Extension
		</a>
		<button class="ml-8" @click="dismissGetBird">
			<BaseIcon
				name="mono/delete"
				class="w-16 h-16 -mt-2 p-2 hover:bg-gray-900 hover:text-yellow-500 rounded-full"
			/>
		</button>
	</span>
</template>

<script>
import analytics from 'shared/utils/analytics'
import isExtensionInstalled from 'shared/mixins/isExtensionInstalled'

export default {
	name: 'ButtonGetBrowserExtension',
	mixins: [isExtensionInstalled],
	data() {
		return {
			getBirdDismissed: localStorage?.getBirdDismissed,
		}
	},
	computed: {
		display() {
			if (!window.chrome) return false
			if (this.getBirdDismissed) return false
			if (!this.$auth.isAuthenticated.value) return false
			if (this.isExtensionInstalled) return false
			return true
		},
	},
	methods: {
		onButtonClick() {
			analytics.track('"Get Bird" Button Clicked', {cta: 'Session Details Header'})
		},
		dismissGetBird() {
			if (localStorage) localStorage.getBirdDismissed = true
			this.getBirdDismissed = true
			analytics.track('"Get Bird" Button Dismissed')
		},
	},
}
</script>
